module.exports = __webpack_public_path__ + "static/img/colors.675885b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/colors.png
// module id = 651
// module chunks = 0